export default {"src":"/_next/static/media/earth_point_logo.dc55d367.svg","height":20,"width":190,"blurWidth":0,"blurHeight":0};